import React from "react";

import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { AiOutlinePrinter } from "react-icons/ai";

import { PrintButtonAuditoria } from "../PrintButtonAuditoria";

const ItemMenu = ({ icone, texto, loading, ...rest }) => (
  <MenuItem
    color="#374BCE"
    p={2}
    cursor={loading ? "wait" : "pointer"}
    {...rest}
  >
    {icone}
    <Text ml="5px">{texto}</Text>
  </MenuItem>
);

// Menu de 3 pontinhos (Visualizar / Imprimir) usado na listagem e no cabeçalho
// do detalhamento. `visualizar` é o item "Visualizar" já pronto (cada tela tem
// um comportamento próprio) e `imprimir` emite o relatório de auditoria em PDF.
export default function MenuOpcoesAuditoria({
  visao,
  id,
  filtrosOrigem,
  visualizar,
  boxSize = "34px",
}) {
  return (
    <Menu isLazy={false}>
      <MenuButton
        as={IconButton}
        aria-label="Opções"
        icon={<BsThreeDots color="#fff" fontSize="20px" />}
        variant="link"
        cursor="pointer"
        backgroundColor="#95BCBF"
        color="#fff"
        rounded={100}
        minW={boxSize}
        boxSize={boxSize}
      />
      <MenuList>
        {visualizar}
        <PrintButtonAuditoria
          visao={visao}
          id={id}
          filtrosOrigem={filtrosOrigem}
          trigger={(loading) => (
            <ItemMenu
              icone={<AiOutlinePrinter />}
              texto="Imprimir"
              loading={loading}
            />
          )}
        />
      </MenuList>
    </Menu>
  );
}

export const ItemVisualizar = ({ onClick, loading }) => (
  <ItemMenu
    icone={<BsEye />}
    texto="Visualizar"
    loading={loading}
    onClick={onClick}
  />
);
